import type { KickPlateFixingHoles } from 'metalworks-domain'

import { AttributeToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

interface KickPlateHolesCountPropertyPageProps {
  id: KickPlateFixingHoles['id']
}

export const KickPlateHolesCountPropertyContainerItem = (props: KickPlateHolesCountPropertyPageProps) => {
  const { id } = props

  return (
    <>
      <PropertyContainer.Item title="Number of Horizontal Holes">
        <AttributeToggleSelector entityId={id} instanceName="horizontalCount" />
      </PropertyContainer.Item>
      <PropertyContainer.Item title="Number of Vertical Holes">
        <AttributeToggleSelector entityId={id} instanceName="verticalCount" />
      </PropertyContainer.Item>
    </>
  )
}

export const KickPlateHolesCountPropertyPage = (props: KickPlateHolesCountPropertyPageProps) => (
  <PropertyContainer.Group spacing="large">
    <KickPlateHolesCountPropertyContainerItem {...props} />
  </PropertyContainer.Group>
)
